import * as React from 'react';
import { ProductDetailDrawer } from '../../ProductDetailDrawer/ProductDetailDrawer.js';
import { ProductDetailReviewsCTA } from './components/ProductDetailReviewsCTA/ProductDetailReviewsCTA.js';

const ProductDetailReviews = ({ title , children  })=>/*#__PURE__*/ React.createElement(ProductDetailDrawer, {
        title: title,
        "data-t": "reviews-drawer",
        ctaButton: /*#__PURE__*/ React.createElement(ProductDetailReviewsCTA, {
            title: title
        }),
        shouldMountContent: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-reviews__content"
    }, children))
;

export { ProductDetailReviews };
//# sourceMappingURL=ProductDetailReviews.js.map
